import PropTypes from 'prop-types';
import React from 'react';
import { Map } from 'immutable';
import Button from '@material-ui/core/Button';
import AddIcon from '@mui/icons-material/Add';

import Milestone from './Milestone';

const FormMilestones = ({ fields }) => (
  <>
    {fields.map((milestone, index) => {
      const remove = () => fields.remove(index);
      return (
        <Milestone
          key={milestone._id || index}
          milestone={milestone}
          index={index}
          remove={remove}
          move={fields.move}
        />
      );
    })}
    <Button
      type="button"
      onClick={() => fields.push(new Map())}
      color="primary"
      variant="contained"
      size="small"
      style={{ marginTop: 15, paddingRight: 15 }}
    >
      <AddIcon /> Add Milestone
    </Button>
  </>
);
FormMilestones.propTypes = {
  fields: PropTypes.object.isRequired,
};
export default FormMilestones;
